import {SvgIcon, SvgIconProps} from "@mui/material";
import React from "react";

export const GitlabIcon = (props: SvgIconProps) => (
  <SvgIcon
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 500 500"
    {...props}
  >
      <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
          <g>
              <g transform="translate(2 19)">
                  <g>
                      <g>
                          <g transform="matrix(1 0 0 -1 0 457.333)">
                              <g>
                                  <g>
                                      <g>
                                          <g transform="translate(.667 .667)">
                                              <g fill="#FC6D26" transform="translate(.532 .775)">
                                                  <path
                                                    d="M492 194.667l-27.559 84.814-54.617 168.098c-2.81 8.648-15.045 8.648-17.856 0L337.349 279.48H155.983l-54.62 168.098c-2.81 8.648-15.046 8.648-17.856 0L28.889 279.48 1.332 194.667a18.775 18.775 0 016.82-20.992L246.665.385l238.515 173.29a18.777 18.777 0 016.82 20.992"></path>
                                              </g>
                                              <g fill="#E24329" transform="translate(156.198 1.16)">
                                                  <path d="M91 0l90.684 279.096H.316L91 0z"></path>
                                              </g>
                                              <g fill="#FC6D26" transform="translate(28.531 1.16)">
                                                  <path d="M218.667 0l-90.684 279.095H.89L218.667 0z"></path>
                                              </g>
                                              <g fill="#FCA326" transform="translate(.089 .256)">
                                                  <path
                                                    d="M29.333 280L1.775 195.185a18.773 18.773 0 016.821-20.99L247.109.905 29.333 280z"></path>
                                              </g>
                                              <g
                                                fill="#E24329"
                                                transform="translate(29.422 280.256)"
                                              >
                                                  <path
                                                    d="M0 0h127.092L72.473 168.097c-2.81 8.65-15.046 8.65-17.856 0L0 0z"></path>
                                              </g>
                                              <g fill="#FC6D26" transform="translate(247.198 1.16)">
                                                  <path d="M0 0l90.684 279.095h127.092L0 0z"></path>
                                              </g>
                                              <g fill="#FCA326" transform="translate(246.307 .256)">
                                                  <path
                                                    d="M218.667 280l27.558-84.815a18.773 18.773 0 00-6.821-20.99L.891.905 218.667 280z"></path>
                                              </g>
                                              <g
                                                fill="#E24329"
                                                transform="translate(336.974 280.256)"
                                              >
                                                  <path
                                                    d="M128 0H.908l54.619 168.097c2.81 8.65 15.046 8.65 17.856 0L128 0z"></path>
                                              </g>
                                          </g>
                                      </g>
                                  </g>
                              </g>
                          </g>
                      </g>
                  </g>
              </g>
          </g>
      </g>
  </SvgIcon>
);
